/* tslint:disable */
/* eslint-disable */
/**
 * TOM ADMIN SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerDamageTypeDto } from '../model';
// @ts-ignore
import type { CreateContainerDamageTypeCommand } from '../model';
// @ts-ignore
import type { UpdateContainerDamageTypeCommand } from '../model';
/**
 * ContainerDamageTypesApi - axios parameter creator
 */
export const ContainerDamageTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('containerDamageTypesDelete', 'id', id)
            const localVarPath = `/admin/api/ContainerDamageTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/ContainerDamageTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateContainerDamageTypeCommand} [createContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesPost: async (createContainerDamageTypeCommand?: CreateContainerDamageTypeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/ContainerDamageTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContainerDamageTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageTypeCommand} [updateContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesPut: async (id: number, updateContainerDamageTypeCommand?: UpdateContainerDamageTypeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('containerDamageTypesPut', 'id', id)
            const localVarPath = `/admin/api/ContainerDamageTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContainerDamageTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerDamageTypesApi - functional programming interface
 */
export const ContainerDamageTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerDamageTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageTypesDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageTypesDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageTypesApi.containerDamageTypesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerDamageTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageTypesApi.containerDamageTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateContainerDamageTypeCommand} [createContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageTypesPost(createContainerDamageTypeCommand?: CreateContainerDamageTypeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageTypesPost(createContainerDamageTypeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageTypesApi.containerDamageTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageTypeCommand} [updateContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerDamageTypesPut(id: number, updateContainerDamageTypeCommand?: UpdateContainerDamageTypeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerDamageTypesPut(id, updateContainerDamageTypeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerDamageTypesApi.containerDamageTypesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerDamageTypesApi - factory interface
 */
export const ContainerDamageTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerDamageTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.containerDamageTypesDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerDamageTypeDto>> {
            return localVarFp.containerDamageTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateContainerDamageTypeCommand} [createContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesPost(createContainerDamageTypeCommand?: CreateContainerDamageTypeCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.containerDamageTypesPost(createContainerDamageTypeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContainerDamageTypeCommand} [updateContainerDamageTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerDamageTypesPut(id: number, updateContainerDamageTypeCommand?: UpdateContainerDamageTypeCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.containerDamageTypesPut(id, updateContainerDamageTypeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerDamageTypesApi - object-oriented interface
 */
export class ContainerDamageTypesApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageTypesDelete(id: number, options?: RawAxiosRequestConfig) {
        return ContainerDamageTypesApiFp(this.configuration).containerDamageTypesDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageTypesGet(options?: RawAxiosRequestConfig) {
        return ContainerDamageTypesApiFp(this.configuration).containerDamageTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateContainerDamageTypeCommand} [createContainerDamageTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageTypesPost(createContainerDamageTypeCommand?: CreateContainerDamageTypeCommand, options?: RawAxiosRequestConfig) {
        return ContainerDamageTypesApiFp(this.configuration).containerDamageTypesPost(createContainerDamageTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateContainerDamageTypeCommand} [updateContainerDamageTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerDamageTypesPut(id: number, updateContainerDamageTypeCommand?: UpdateContainerDamageTypeCommand, options?: RawAxiosRequestConfig) {
        return ContainerDamageTypesApiFp(this.configuration).containerDamageTypesPut(id, updateContainerDamageTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

